<template lang="pug">
    .z-input-finance-operation
        .z-input-finance-operation__sum
            .z-input-finance-operation__sum-label Сумма:
            .z-input-finance-operation__sum-value {{priceFormat(sum) + ' руб.'}}
            md-button.md-icon-button.md-dense.close.small.full-price-btn(
                v-if="operations && operations.length"
                v-on:click="toggleOperations"
            )
                i.fas.fa-chevron-down
            z-button.z-input-finance-operation__sum-add(
                v-if="!$props.disabled && parseFloat(sum) < parseFloat($props.price)"
                v-bind:radius="3"
                v-bind:uppercase="false"
                v-on:click="toggleForm"
            )
                template
                    md-icon add
                    | Принять платеж

        .z-input-finance-operation__operations(
            v-if="operations && operations.length && viewOperations"
            ref="operationList"
        )
            .z-input-finance-operation__operations__item(v-for='(operation, i) in operations' v-if="parseInt(operation.type) === 1")
                md-tooltip(md-direction="bottom" md-delay="500" v-if="operation.payment_method_id") {{ getPaymentMethodById(operation.payment_method_id) }}
                .z-input-finance-operation__operations__item-date {{moment(operation.date).tz($root.userTimezone).format('DD.MM.YYYY HH:mm')}}
                .z-input-finance-operation__operations__item-sum {{priceFormat(operation.sum) + ' руб.'}}

                .z-input-finance-operation__operations__item-actions(v-if="!operation.id || isUserAdmin")
                    md-button.md-icon-button.md-dense.close.small(v-on:click="editOperation(operation, i)")
                        md-icon mode_edit
                        md-tooltip(md-direction="bottom" md-delay="500") Редактировать
                    md-button.md-accent.md-icon-button.md-dense.close.small(v-on:click="removeOperation(operation, i)")
                        md-icon delete
                        md-tooltip(md-direction="bottom" md-delay="500") Удалить
                        
        .z-input-finance-operation__dialog(v-if="viewForm" ref="operationDialog")
            z-select(
                v-if="correctPayers"
                name="finance-customer-id" id="fincane-customer-id" placeholder="Плательщик"
                v-model="operation.customer_id" v-bind:data-vv-as="' '"
                v-validate="{required: true}" v-bind:error="errors.first('finance-customer-id')"
                inline required
            )
                option(value="") Плательщик
                option(v-for="(payer, i) in correctPayers" v-bind:key="(payer.id + '-' + i)" v-bind:value="payer.id") {{payer.name}}

            .error(v-show="operation.customer_id && !canAcceptPayment") Невозможно принять платёж выбранным способом оплаты

            z-select(
                v-show="canAcceptPayment"
                name="fincane-payment-method-id" id="fincane-payment-method-id"
                v-model="operation.payment_method_id" v-bind:required="true" 
                v-validate="'required'" data-vv-name="fincane-payment-method-id" v-bind:data-vv-as="' '"
                v-bind:error="errors.first('fincane-payment-method-id')"
                disabled inline required
            )
                option(value="") Способ оплаты
                option(v-for="item in $props.paymentMethods" v-bind:value="item.id") {{item.name}}

            z-input(
                v-show="canAcceptPayment"
                name="sum" id="sum" placeholder="Сумма (руб.)" type="number" v-model="operation.sum" 
                v-validate="{required: true, min_value: 0, max_value: maxPayerPrice}" v-bind:error="errors.first('sum')"
                v-bind:data-vv-as="' '"
                border no-margin
            )
            z-date(
                v-show="canAcceptPayment"
                placeholder="Дата платежа" format="DD.MM.YYYY HH:mm" type="datetime" v-model="operation.date"
                data-vv-name="date" v-bind:data-vv-as="' '" v-validate="{'required': true, before: currentDate}"
                v-bind:error="(errors.first('date') ? ('Укажите корректную дату, до ' + moment().tz($root.userTimezone).add(1, 'minutes').format('DD.MM.YYYY HH:mm')) : null )"
                v-bind:disabled="!isUserAdmin"
                required no-margin
            )
 
            z-button(v-show="canAcceptPayment" @click="save" light) {{ operation.date ? 'Сохранить' : 'Добавить' }}
</template>
<script>
    import ZInput from './ZInput.vue';
    import ZButton from './ZButton.vue';
    import ZDate from '@/components/ZDate';
    import ZSelect from '@/components/ZSelect';
    import priceFormat from "@/mixins/priceFormat";
    export default {
        name: 'z-input-finance-operation',
        props: {
            dealId: {
                type: Number,
                default: null
            },
            companyId: {
                type: Number,
                default: null
            },
            price: {
                type: Number,
                default: null
            },
            payersPrice: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            value: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            requiredFullPrice: {
                type: Boolean,
                default: false
            },
            payers: {
                type: Array,
                default: []
            },
            paymentMethods: {
                type: Array,
                default: [],
                required: true
            },
            dirty: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        components: {ZInput, ZButton, ZDate, ZSelect},
        data() {
            return {
                priceFormat: priceFormat,
                isDirty: false,
                operation: {
                    id:   null,
                    sum:  null, //Сумма
                    type: 1,    //1 - Приход, 2 - Расход
                    date: null, //Дата операции
                    payment_number: null, //Номер платёжки
                    company_id:  null, //Компания - исполнитель
                    customer_id: null, //Плательщик
                    deal_id:     null, //ID заявки
                    description: null, //Описание
                    index: null,
                    payment_method_id: null,
                },
                operationDefault: {
                    id:   null,
                    sum:  null, //Сумма
                    date: null, //Дата операции
                    type: 1,    //1 - Приход, 2 - Расход
                    payment_number: null, //Номер платёжки
                    company_id:  null, //Компания - исполнитель
                    customer_id: null, //Плательщик
                    deal_id:     null, //ID заявки
                    description: null, //Описание
                    index: null,
                    payment_method_id: null
                },
                currentDate: null,
                viewForm: false,
                viewOperations: false,
                operations: []
            }
        },
        created() {
            this.$nextTick(() => this.init());
        },
        watch: {
            '$props.value'() {
                this.$nextTick(() => this.init());
            },
            'viewForm'(val) {
                if (val && this.maxPayerPriceByDeal && !this.operation.id)
                    this.operation.sum = this.maxPayerPriceByDeal;
            },
            'operation.customer_id'(val) {
                if (val && this.maxPayerPriceByDeal && !this.operation.id)
                    this.operation.sum = this.maxPayerPriceByDeal;
            },
            'selectedPayer'(payer) {
                if (payer && payer.payment_method_id) this.operation.payment_method_id = parseInt(payer.payment_method_id);
            },
            '$props.dirty'(val) {
                if (val && this.isDirty !== val) this.emitDirty();
            }
        },
        computed: {
            correctPayers() {
                if (!this.$props.payers) return [];
                return this.$props.payers.filter(payer => (!!payer.id && !!payer.name));
            },
            sum() {
                let result = 0;
                if (!this.operations || !this.operations.length) return result;
                this.operations.map(item => {
                    if (parseInt(item.type) === 1) result += parseFloat(item.sum);
                });
                return result.toFixed(3);
            },
            minPrice() {
                return (this.$props.requiredFullPrice) ? (parseFloat(this.$props.price) - parseFloat(this.sum)) : 0.001;
            },
            maxPrice() {
                return (parseFloat(this.$props.price) - parseFloat(this.sum)).toFixed(3);
            },

            payerSum() {
                if (!this.operation.customer_id) return 0;
                const cid = this.operation.customer_id;

                let result = 0;
                if (!this.operations || !this.operations.length) return result;
                this.operations.filter(item => parseInt(item.customer_id) === parseInt(cid)).map(item => {
                    if (parseInt(item.type) === 1) result += parseFloat(item.sum);
                });
                
                return result.toFixed(3);
            },
            minPayerPrice() {
                if (!this.operation.customer_id) return 0;
                const cid   = this.operation.customer_id;
                const price = (this.$props.payersPrice && this.$props.payersPrice[cid] && this.$props.payersPrice[cid]['result']) ? this.$props.payersPrice[cid]['result'] : 0;
                
                return (this.$props.requiredFullPrice) ? (parseFloat(price) - parseFloat(this.payerSum)) : 0.001;
            },
            maxPayerPrice() {
                // Клиент попросил отключить верхний порог, поэтому ограничиваем значением decinal(13,2)
                return 9999999999999.99;
                if (!this.operation.customer_id) return 0;
                const cid   = this.operation.customer_id;
                const price = (this.$props.payersPrice && this.$props.payersPrice[cid] && this.$props.payersPrice[cid]['result']) ? this.$props.payersPrice[cid]['result'] : 0;

                return this.operation.id ? parseFloat(price) : (parseFloat(price) - parseFloat(this.payerSum));
            },
            maxPayerPriceByDeal() {
                if (!this.operation.customer_id) return 0;
                const cid   = this.operation.customer_id;
                const price = (this.$props.payersPrice && this.$props.payersPrice[cid] && this.$props.payersPrice[cid]['result']) ? this.$props.payersPrice[cid]['result'] : 0;
                return this.operation.id ? parseFloat(price) : (parseFloat(price) - parseFloat(this.payerSum).toFixed(3));
            },
            user() {
                return this.$store.state.users.current;
            },
            isUserAdmin() {
                return (this.user && this.user.groups_codes) ? !!(this.user.groups_codes.indexOf('administrators')+1) : false;
            },
            selectedPayer() {
                if (!this.correctPayers || !this.operation.customer_id) return null;
                return this.correctPayers.find(payer => parseInt(payer.id) === parseInt(this.operation.customer_id));
            },
            canAcceptPayment() {
                if (
                    !this.selectedPayer || !this.selectedPayer.payment_method_id || 
                    parseInt(this.selectedPayer.payment_method_id) === 2
                ) return false;
                return true;
            }
        },
        mounted() {
            this.currentDate = this.moment().tz(this.$root.userTimezone).add(1, 'hours').toDate();
            this.closeListen();
        },
        methods: {
            emitDirty() {
                this.isDirty = true;
                this.$emit('update:dirty', this.isDirty);
            },
            closeListen() {
                this.closeListener = document.addEventListener('click', e => {
                    if (this.$refs && this.$refs.operationDialog && !this.$refs.operationDialog.contains(e.target)) {
                        document.removeEventListener('click', this.closeListener, false);
                        this.hideForm();
                    }
                    if (this.$refs && this.$refs.operationList && !this.$refs.operationList.contains(e.target)) {
                        document.removeEventListener('click', this.closeListener, false);
                        this.viewOperations = false;
                    }
                });
            },
            init() {
                if (this.$props.value && this.$props.value.length) this.operations = Object.assign([], this.$props.value);
            },
            clearForm() {
                this.operation = Object.assign({}, this.operationDefault);
            },
            showForm() {
                this.viewForm = true;
            },
            hideForm() {
                this.viewForm = false;
                this.clearForm();
            },
            toggleForm() {
                this.viewForm = !this.viewForm;
                if (!this.operation.date) this.operation.date = this.moment().format();
            },
            toggleOperations() {
                this.viewOperations = !this.viewOperations;
            },
            save() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) return;
                    this.operation.date        = (this.operation.date) ? this.moment(this.operation.date).format('YYYY-MM-DD HH:mm:ss') : this.moment().format('YYYY-MM-DD HH:mm:ss');
                    this.operation.company_id  = this.$props.companyId;
                    this.operation.deal_id     = this.$props.dealId;

                    if (this.operation.index !== undefined && this.operation.index !== null) this.operations[this.operation.index] = Object.assign({}, this.operation);
                    else this.operations.push(this.operation);

                    this.clearForm();
                    this.$emit('change', this.operations);
                    this.$emit('input', this.operations);
                    this.$emit('save', this.operations);
                    this.hideForm();
                    this.emitDirty();
                });
            },
            removeOperation(operation, i) {
                if (operation.id) {
                    this.$root.$emit('z-alert', 'Удалить финансовую запись?', 'Это повлечёт изменение документов и будет иметь влияние на всю логику грузоперевозки!', () => {
                        this.$store.commit('showProgressBar', 'load-deal-card');
                        this.$store.dispatch('finance/removeOperation', operation.id).then(r => {
                            if (!r) return;
                            this.operations.splice(i, 1);
                            this.$emit('change', this.operations);
                            this.$emit('input', this.operations);
                            this.$emit('remove', operation);
                        }).finally(() => this.$store.commit('hideProgressBar', 'load-deal-card'));
                    });
                } else {
                    this.operations.splice(i, 1);
                    this.$emit('change', this.operations);
                    this.$emit('input', this.operations);
                    this.emitDirty();
                }
            },
            editOperation(operation, i) {
                this.operation = Object.assign({}, operation);
                this.operation.date  = this.moment(this.operation.date).format();
                this.operation.index = parseInt(i);
                this.toggleForm();
                this.emitDirty();
            },
            getPaymentMethodById(id) {
                let PaymentMethod = this.paymentMethods.find(item => parseInt(item.id) === parseInt(id));
                if (PaymentMethod) return PaymentMethod.name;

                return 'Способ оплаты не указан';
            }
        }
    }
</script>
<style lang="sass">
    .z-input-finance-operation
        position: relative
        margin: auto 0 auto auto
        .z-input-finance-operation__sum
            display: flex
            align-items: center
            justify-content: flex-start
            //padding: 0 0 0 65px
            .z-input-finance-operation__sum-label
            .z-input-finance-operation__sum-value
                font-weight: 600
                margin: 0 5px
                color: #67d665
                flex: 0 0 auto
            .z-input-finance-operation__sum-add
                margin-left: 15px
        .z-input-finance-operation__dialog,
        .z-input-finance-operation__operations
            position: absolute
            background: #FFFFFF
            box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.2)
            border-radius: 3px
            padding: 5px
            width: 260px
            z-index: 10
            right: 0
            top: 30px
            &::before
                content: ''
                width: 5.6px
                height: 5.6px
                border-top: 2.8px
                border-left: 2.8px
                transform: rotate(45deg)
                position: absolute
                display: block
                top: -3px
                left: 130px
                right: 0
                margin: auto
                background: #fff
                box-shadow: -2px -2px 4px 0px rgba(0, 0, 0, .1)
            .error
            .z-button
                margin-top: 5px
        .z-input-finance-operation__operations
            right: initial
            left: -85px
            width: auto
            padding: 14px
            &::before
                right: 10px
                left: initial
            .z-input-finance-operation__operations__item
                display: flex
                align-items: center
                justify-content: flex-start
                cursor: default
                .z-input-finance-operation__operations__item-sum
                    flex-shrink: 0
                    font-size: 12px
                    margin: 0 10px
                    color: #333
                    font-weight: 500
                .z-input-finance-operation__operations__item-date
                    flex-shrink: 0
                    font-size: 10px
                    color: #888
                .z-input-finance-operation__operations__item-actions
                    flex-shrink: 0
                    opacity: 0
                    visibility: hidden
                    transition: 0.25s ease-in-out
                &:hover
                    .z-input-finance-operation__operations__item-actions
                        opacity: 1
                        visibility: visible
</style>


// WEBPACK FOOTER //
// ZInputFinanceOperation.vue?eb620728